import { render, staticRenderFns } from "./AddIasProjectsButton.vue?vue&type=template&id=8562640a&"
import script from "./AddIasProjectsButton.vue?vue&type=script&lang=js&"
export * from "./AddIasProjectsButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports